import './schedules.scss';

import * as React from 'react';
import { graphql, Link } from 'gatsby';

import { QueryResult, unwrapNodes } from 'utils/QueryResults';

import * as Core from 'components/core';
import Layout from 'components/Layout';
import ContentWrapper from 'components/ContentWrapper';
import Masthead from 'components/Masthead';

type Props = {
  data: {
    schedules: QueryResult<{
      year: number;
      date: string;
      venue: string;
      location: string;
    }>;
  };
};

const PrivacyPage = (props: Props) => {
  const schedules = unwrapNodes(props.data.schedules);

  return (
    <Layout title="Schedules">
      <ContentWrapper>
        <Masthead title="Schedules" />
        <div className="SchedulesPage">
          {schedules.map((schedule, index) => (
            <Link key={index} to={`/${schedule.year}/schedule`}>
              <h2 className="SchedulesPage-year">
                <Core.PrimaryHeading>{schedule.year}</Core.PrimaryHeading>
              </h2>
            </Link>
          ))}
        </div>
      </ContentWrapper>
    </Layout>
  );
};

export default PrivacyPage;

export const query = graphql`
  query EventSchedules {
    schedules: allSchedule(
      sort: { year: DESC }
      filter: { published: { eq: true } }
    ) {
      edges {
        node {
          year
          date
          venue
          location
        }
      }
    }
  }
`;
